/* eslint-disable no-unused-vars */
import { func, number, oneOfType, string, bool, array } from "prop-types";
import React, { useEffect, useState } from "react";
import { EyeIcon } from "Shared/icons";

import "./input.ui.scss";

export const Input = ({
	placeholder,
	id,
	type,
	errorMessage,
	className = "",
	outValue = "",
	disabled = false,
	setOutValue = () => {},
}) => {
	const [value, setValue] = useState(outValue);
	const [visiblePass, setVisiblePass] = useState(false);
	const errorMessageType = typeof errorMessage;

	function onChange(e) {
		if (value !== e.target.value) {
			setValue(e.target.value);
			setOutValue(e.target.value);
		}
	}
	useEffect(() => {
		if (outValue !== value) {
			setValue(outValue);
		}
	}, [outValue]);

	function toggleVisiblePass() {
		setVisiblePass(!visiblePass);
	}

	function switchType() {
		switch (type) {
			case "password":
				return visiblePass ? "text" : "password";
			case "amount":
				return "number";
			default:
				return type;
		}
	}

	return (
		<div className={`input ${className} `}>
			<div className="input__container">
				<input
					placeholder={placeholder}
					className={`input__input ${errorMessage?.length ? "input__input_error " : ""}`}
					id={id}
					type={switchType()}
					value={value}
					onChange={onChange}
					onBlur={onChange}
					disabled={disabled}
				/>
				{type === "password" && (
					<div className="input__icon input__icon_pass">
						<EyeIcon onClick={toggleVisiblePass} />
					</div>
				)}

				{type === "amount" && <i className="input__icon input__icon_amount">€</i>}
			</div>

			<div className={errorMessage ? "visible" : "hide"}>
				{errorMessageType === "string" ? (
					<div className="input__error">{errorMessage}</div>
				) : (
					<>
						{errorMessage &&
							errorMessage.map((message) => {
								return (
									<div className="input__error" key={message}>
										{message}
									</div>
								);
							})}
					</>
				)}
			</div>
		</div>
	);
};

Input.propTypes = {
	placeholder: string,
	id: string,
	type: string,
	errorMessage: oneOfType([bool, array]),
	className: string,
	outValue: oneOfType([number, string]),
	setOutValue: func,
	icon: bool,
	disabled: bool,
};
